export const environment = {
    production: true,
    apiUrl: 'https://app.tjpb.jus.br/sustentabilidade-forms-backend',
    keycloak: {
        url: 'https://keycloak.tjpb.jus.br/login',
        realm: 'apps-prod',
        clientId: 'sustentabilidade-forms'
    }
};
